import { Box, Button, Dialog, Portal, Stack } from '@chakra-ui/react'
import { Field, Formik } from 'formik'
import { useEffect } from 'react'
import { Form, InputForm, SwitchForm } from 'uikit'
import * as Yup from 'yup'
import { useSettingsFetch } from './services/useSettingsFetch'
import { useSettingsUpdate } from './services/useSettingsUpdate'

const formSchema = Yup.object({
  circuitBreakerFreq1: Yup.number()
    .integer('invalid decimal')
    .min(0, 'Min')
    .required('Заполните поле'),
  circuitBreakerFreq2: Yup.number()
    .integer('invalid decimal')
    .min(0, 'Min')
    .required('Заполните поле'),
  circuitBreakerPeriod1: Yup.number()
    .integer('invalid decimal')
    .min(0, 'Min')
    .required('Заполните поле'),
  circuitBreakerPeriod2: Yup.number()
    .integer('invalid decimal')
    .min(0, 'Min')
    .required('Заполните поле'),
})

export const ErrorOpenApiSettings = ({ isOpen, onClose }) => {
  const { refetch: getSettings, isPending: isLoadingFetch, data } = useSettingsFetch()
  const settingsData = data?.[0]
  const { mutate: updateSettings, isPending: isLoadingUpdate } = useSettingsUpdate()

  useEffect(() => {
    if (isOpen) {
      getSettings()
    }
  }, [isOpen])

  const handleForm = (values) => {
    const dataRequest = {
      ...settingsData,
      circuitBreakerEnabled: values?.circuitBreakerEnabled ? 1 : 0,
      circuitBreakerFreq1: Number(values.circuitBreakerFreq1),
      circuitBreakerFreq2: Number(values.circuitBreakerFreq2),
      circuitBreakerPeriod1: Number(values.circuitBreakerPeriod1),
      circuitBreakerPeriod2: Number(values.circuitBreakerPeriod2),
    }

    updateSettings(dataRequest, {
      onSuccess: () => {
        onClose()
      }
    })
  }

  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Настройка ошибок OpenApi</Dialog.Title>
              <Dialog.CloseTrigger />
            </Dialog.Header>
            <Dialog.Body>
              <Formik
                enableReinitialize
                validationSchema={formSchema}
                initialValues={{
                  circuitBreakerEnabled: settingsData?.circuitBreakerEnabled === 1,
                  circuitBreakerFreq1: String(settingsData?.circuitBreakerFreq1) ?? 0,
                  circuitBreakerFreq2: String(settingsData?.circuitBreakerFreq2) ?? 0,
                  circuitBreakerPeriod1: String(settingsData?.circuitBreakerPeriod1) ?? 0,
                  circuitBreakerPeriod2: String(settingsData?.circuitBreakerPeriod2) ?? 0,
                }}
                onSubmit={handleForm}
              >
                {(props) => (
                  <Form onSubmit={props.handleSubmit}>
                    <Stack gap={4}>
                      <Field name="circuitBreakerEnabled" label="Активно" component={SwitchForm} />
                      <Field
                        name="circuitBreakerPeriod1"
                        label="Период 1 (секунды)"
                        component={InputForm}
                        placeholder="0"
                      />
                      <Field
                        name="circuitBreakerFreq1"
                        label="Число попыток 1"
                        component={InputForm}
                        placeholder="0"
                      />
                      <Field
                        name="circuitBreakerPeriod2"
                        label="Период 2 (секунды)"
                        component={InputForm}
                        placeholder="0"
                      />
                      <Field
                        name="circuitBreakerFreq2"
                        label="Число попыток 2"
                        component={InputForm}
                        placeholder="0"
                      />
                    </Stack>
                    <Box pt="30px">
                      <Button
                        type="submit"
                        colorPalette="orange"
                        loading={isLoadingUpdate || isLoadingFetch}
                      >
                        Сохранить
                      </Button>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
